import {
   ChangeDetectionStrategy,
   Component,
   ContentChildren,
   Input,
   isDevMode,
   OnInit,
   QueryList,
} from '@angular/core';
import { LcsOptionComponent } from '../../select/option/option.component';

import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../single-select-base';

let nextUniqueId = 0;

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'lcs-static-select',
    templateUrl: './static-select.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: LcsStaticSingleSelectComponent,
        },
    ],
    standalone: false
})
export class LcsStaticSingleSelectComponent<TItem> extends LcsSingleSelectBase<TItem> implements OnInit {
   @Input() displayWith: (item: TItem | null) => string | null = (item) => {
      return `${item ?? ''}`;
   };

   @Input() trackBy: (item: TItem | null) => any;

   @ContentChildren(LcsOptionComponent, { descendants: true }) set contentChildrenOptions(
      value: QueryList<LcsOptionComponent<TItem>>
   ) {
      if (!this.options) {
         this.options = value;
      }
   }

   /** Unique ID to be used by autocomplete trigger's "aria-owns" property. */
   id = `lcs-static-single-select-${++nextUniqueId}`;

   ngOnInit(): void {
      if (isDevMode() && !this.displayWith) {
         throw new Error('displayWith is required for StaticSelectComponent');
      }
   }
}
